import SearchLoadsView from './SearchLoadsView';

export default SearchLoadsView;
